export default "__VITE_ASSET__p_SCbjZv__"